import React from "react";
import { useTranslation } from "react-i18next";
import Star from "../../Asset/icon/star.svg";
import Location from "../../Asset/icon/location.svg";
import Rope from "../../Asset/icon/Rope.svg";

const ThumbnailCard = ({
  image,
  headline,
  location,
  province,
  vaildDate,
  price,
  originalPrice,
  currency,
  discount_promotion,
  discount_value_promotion,
}) => {
  const { t } = useTranslation();

  const formatPrice = (price) => {
    return new Intl.NumberFormat().format(price);
  };

  return (
    <div>
      <div className="card-hotdeal">
        <div className="image-container-hotdeal">
          <img
            aria-hidden={true}
            draggable={false}
            src={image || "Yacht.jpg"}
            className="carousel-image-hotdeal"
            alt="carousel-image-hotdeal"
          />
          <div className="hotDeal-OFF">
            <img
              src={Star}
              draggable={false}
              className="star-hotDeal"
              alt="star-hotDeal"
            />
            <p className="desktop-only">
              Hot deal {discount_value_promotion} {discount_promotion} OFF
            </p>

            <p className="mobile-only">
              {discount_value_promotion} {discount_promotion} OFF
            </p>
            {/* <p>
              Hot deal {discount_value_promotion} {discount_promotion} OFF
            </p> */}
          </div>
        </div>
        <div className="content-hotdeal">
          <h3 className="yacht-font-w">{headline}</h3>
          <div className="location">
            <img src={Location} draggable={false} alt="Location" />
            <p>{`${location}${province ? `, ${province}` : ""}`}</p>
          </div>
          <div className="vaildDate">
            <h3>{t("Offer Ends")}</h3>
            <p> {vaildDate}</p>
          </div>

          <div className="price-containers">
            <div className="col-5">
              <img
                src={Rope}
                draggable={false}
                className="hover-rope"
                alt="hover-rope"
              />
            </div>
            <div className="price-details">
              <p className="original-price">{formatPrice(originalPrice)}</p>
              <div className="content-price">
                <h4 className="thb-currency">{currency}</h4>&nbsp;
                <p className="text-danger">{formatPrice(price)}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThumbnailCard;
